var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "dataForm",
          attrs: {
            model: _vm.childData,
            rules: _vm.rules,
            "label-position": "right",
            "label-width": "130px"
          }
        },
        [
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "领取人姓名", prop: "receiveUserName" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "300px" },
                        attrs: { maxlength: "10" },
                        model: {
                          value: _vm.childData.receiveUserName,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "receiveUserName", $$v)
                          },
                          expression: "childData.receiveUserName"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "领取人联系方式",
                        prop: "receiveUserPhone"
                      }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "300px" },
                        attrs: { maxlength: "11" },
                        model: {
                          value: _vm.childData.receiveUserPhone,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "receiveUserPhone", $$v)
                          },
                          expression: "childData.receiveUserPhone"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: "领取人住址", prop: "receiveUserAdder" }
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "300px" },
                        attrs: { maxlength: "20" },
                        model: {
                          value: _vm.childData.receiveUserAdder,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "receiveUserAdder", $$v)
                          },
                          expression: "childData.receiveUserAdder"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "领取时间", prop: "receiveDate" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "300px" },
                        attrs: {
                          type: "datetime",
                          format: "yyyy-MM-dd HH:mm",
                          "value-format": "yyyy-MM-dd HH:mm",
                          placeholder: "选择领取时间"
                        },
                        model: {
                          value: _vm.childData.receiveDate,
                          callback: function($$v) {
                            _vm.$set(_vm.childData, "receiveDate", $$v)
                          },
                          expression: "childData.receiveDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "el-row",
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "el-form-item",
                    { staticClass: "required", attrs: { label: "领取物品" } },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          staticStyle: { width: "300px" },
                          model: {
                            value: _vm.goodsIdList,
                            callback: function($$v) {
                              _vm.goodsIdList = $$v
                            },
                            expression: "goodsIdList"
                          }
                        },
                        _vm._l(_vm.goodsList, function(goods) {
                          return _c(
                            "el-checkbox",
                            {
                              key: goods.goodId,
                              attrs: { label: goods.goodId }
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticStyle: {
                                    display: "inline-block",
                                    "white-space": "pre-wrap",
                                    width: "300px"
                                  }
                                },
                                [_vm._v(_vm._s(goods.goodsName))]
                              )
                            ]
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c("el-button", { on: { click: _vm.handCancle } }, [
            _vm._v(_vm._s(_vm.$t("button.cancel")))
          ]),
          _c(
            "el-button",
            { attrs: { type: "primary" }, on: { click: _vm.handCreate } },
            [_vm._v(_vm._s(_vm.$t("button.confirm")))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }